import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { submit as submitForm, isDirty } from 'redux-form';
import { Button, Header, Modal } from 'semantic-ui-react';
import { toastError, toastSuccess } from 'Common/ToastHelper';
import { has } from 'lodash';

import {
  getSelectServedItemsTableData,
  loading,
} from './state/servedItemsToSite/actions';
import { ServedItemAccessFieldEnum as Fields } from 'Common/FieldEnum';
import { AssignServedItemsToSiteForm } from './components/AssignServedItemsToSiteForm';
import { ASSIGN_SERVED_ITEMS_TO_SITE_FORM_NAME } from 'Common/FormEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import MPWWebApi from 'API/MPWApi';

class AssignServedItemsToSite extends Component {
  static props = {
    onClose: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    siteId: PropTypes.string.isRequired,
  };

  componentDidMount() {
    this.props.getSelectServedItemsTableData(this.props.siteId);
  }

  saveSelectedItemsToSite = async selectedItems => {
    const { siteId, loading, resetDirty, onClose } = this.props;
    loading(true);

    try {
      await MPWWebApi.postGenericInsertUpdate(
        `sitemaster/writeserveditemstosite`,
        { siteId, ...selectedItems }
      );

      toastSuccess(`Updated served items.`);
    } catch (error) {
      has(error, 'response.data.Errors')
        ? error.response.data.Errors.forEach(e => {
            toastError(e.Title);
          })
        : toastError(error.response.statusText);
      return loading(false);
    }

    resetDirty();
    loading(false);
    onClose();
  };

  render() {
    const {
      name,
      onClose,
      siteId,
      selectedServedItems,
      servedItems,
      isloading,
      submitForm,
      isFormDirty,
    } = this.props;
    return (
      <Modal open closeIcon size="large" onClose={onClose}>
        <Header icon="food" content={`Assign served items to site: ${name}`} />
        <Modal.Content>
          <AssignServedItemsToSiteForm
            onSubmit={this.saveSelectedItemsToSite}
            initialValues={{
              [Fields.ItemIds]: selectedServedItems,
            }}
            siteId={siteId}
            loading={isloading}
            servedItems={servedItems}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            positive
            inverted
            color="orange"
            size="big"
            content="Save"
            disabled={!isFormDirty || isloading}
            onClick={() => submitForm(ASSIGN_SERVED_ITEMS_TO_SITE_FORM_NAME)}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { ServedItemsToSite } = state.ServedItemAccessSetupState;
  return {
    isloading: ServedItemsToSite.fetching,
    servedItems: ServedItemsToSite.servedItems,
    selectedServedItems: ServedItemsToSite.selectedServedItems,
    isFormDirty: isDirty(ASSIGN_SERVED_ITEMS_TO_SITE_FORM_NAME)(state),
  };
};

export const AssignServedItemsToSiteModal = withRouter(
  connect(
    mapStateToProps,
    {
      getSelectServedItemsTableData,
      submitForm,
      resetDirty,
      loading,
    }
  )(AssignServedItemsToSite)
);



// WEBPACK FOOTER //
// ./src/pages/serveditemaccesssetup/AssignServedItemsToSiteModal.js